// extracted by mini-css-extract-plugin
module.exports = {"Value":"Gauge_Value__1Rl22","Small":"Gauge_Small__11Tgj","Unit":"Gauge_Unit__2Oshn"};